__turbopack_context__.v({
  "brandLink": "bULsQq_brandLink",
  "detailIconRow": "bULsQq_detailIconRow",
  "insideSection": "bULsQq_insideSection",
  "insideSectionTitle": "bULsQq_insideSectionTitle",
  "productLink": "bULsQq_productLink",
  "setItemsLabel": "bULsQq_setItemsLabel",
  "setItemsWrapper": "bULsQq_setItemsWrapper",
  "singleSetItem": "bULsQq_singleSetItem",
  "wrapper": "bULsQq_wrapper",
});
